import React from 'react';

import {FlyToInterpolator} from 'react-map-gl';

import SchoolIcon from '@material-ui/icons/School';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import SportsHandballIcon from '@material-ui/icons/SportsHandball';
import NatureIcon from '@material-ui/icons/Nature';
import DirectionsBusIcon from '@material-ui/icons/DirectionsBus';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AllOutIcon from '@material-ui/icons/AllOut';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import MusicNoteIcon from '@material-ui/icons/MusicNote';

import Cercanias from './components/icons/Cercanias';
import Teatro from './components/icons/Teatro';

export const INITIAL_VIEWPORT = {
  latitude: 40.24859,
  longitude: -3.69706,
  zoom: 14,
  bearing: 0,
  pitch: 0,
  transitionDuration: 1000,
  transitionInterpolator: new FlyToInterpolator(),
};

export const MAPSTYLEURL = 'style.json';

const poiIconStyle = {
  color: '#005C7E',
  fontSize: 18,
  filter: 'drop-shadow(2px 2px 1px rgba(0,0,0,.2))'
};

const siteIconStyle = {
  color: '#000000',
  fontSize: 20
};

export const MAP_LEGEND = [{
  id: 'educacion',
  name: 'Educación',
  type: 'icon',
  icon: <SchoolIcon style={poiIconStyle}/>
}, {
  id: 'salud',
  name: 'Salud',
  type: 'icon',
  icon: <LocalHospitalIcon style={poiIconStyle}/>
}, {
  id: 'deportes',
  name: 'Deportes',
  type: 'icon',
  icon: <SportsHandballIcon style={poiIconStyle}/>
}, {
  id: 'medioambiente',
  name: 'Medioambiente',
  type: 'icon',
  icon: <NatureIcon style={poiIconStyle}/>
}, {
  id: 'renfe',
  name: 'Cercanías',
  type: 'icon',
  icon: <Cercanias style={poiIconStyle}/>
}, {
  id: 'bus',
  name: 'Bus',
  type: 'icon',
  icon:  <DirectionsBusIcon style={poiIconStyle}/>
}];

export const WIDESCREEN_STEP = '770px';
export const DRAWER_WIDTH = '300px';

export const MODES = [{
  id: 'foot',
  label: 'A Pie',
  icon: <DirectionsWalkIcon/>
}, {
  id: 'cycling',
  label: 'En Bicicleta',
  icon: <DirectionsBikeIcon/>
}];

export const SITES = [{
  id: 'escuela-musica',
  label: 'Escuela Municipal de Música',
  icon: <MusicNoteIcon style={siteIconStyle}/>,
  lat: 40.256270,
  lon: -3.698774
}, {
  id: 'plaza-david-martin',
  label: 'Plaza de David Martín',
  icon:<AllOutIcon style={siteIconStyle}/>,
  lat: 40.252041,
  lon: -3.695169
}, {
  id: 'teatro-francisco-rabal',
  label: 'Teatro Francisco Rabal',
  icon:<Teatro style={siteIconStyle}/>,
  lat: 40.242149,
  lon: -3.693925
}, {
  id: 'ayuntamiento',
  label: 'Ayuntamiento de Pinto',
  icon: <AccountBalanceIcon style={siteIconStyle}/>,
  lat: 40.240990,
  lon: -3.700105
}];

export const SOURCES = {
  'donut-cycling-ayuntamiento': {
    type: 'geojson',
    data: 'isochrones/donut-cycling-ayuntamiento.geojson'
  },
  'donut-cycling-escuela-musica': {
    type: 'geojson',
    data: 'isochrones/donut-cycling-escuela-musica.geojson'
  },
  'donut-cycling-plaza-david-martin': {
    type: 'geojson',
    data: 'isochrones/donut-cycling-plaza-david-martin.geojson'
  },
  'donut-cycling-teatro-francisco-rabal': {
    type: 'geojson',
    data: 'isochrones/donut-cycling-teatro-francisco-rabal.geojson'
  },
  'donut-foot-ayuntamiento': {
    type: 'geojson',
    data: 'isochrones/donut-foot-ayuntamiento.geojson'
  },
  'donut-foot-escuela-musica': {
    type: 'geojson',
    data: 'isochrones/donut-foot-escuela-musica.geojson'
  },
  'donut-foot-plaza-david-martin': {
    type: 'geojson',
    data: 'isochrones/donut-foot-plaza-david-martin.geojson'
  },
  'donut-foot-teatro-francisco-rabal': {
    type: 'geojson',
    data: 'isochrones/donut-foot-teatro-francisco-rabal.geojson'
  },
  'outer-cycling-ayuntamiento': {
    type: 'geojson',
    data: 'isochrones/outer-cycling-ayuntamiento.geojson'
  },
  'outer-cycling-escuela-musica': {
    type: 'geojson',
    data: 'isochrones/outer-cycling-escuela-musica.geojson'
  },
  'outer-cycling-plaza-david-martin': {
    type: 'geojson',
    data: 'isochrones/outer-cycling-plaza-david-martin.geojson'
  },
  'outer-cycling-teatro-francisco-rabal': {
    type: 'geojson',
    data: 'isochrones/outer-cycling-teatro-francisco-rabal.geojson'
  },
  'outer-foot-ayuntamiento': {
    type: 'geojson',
    data: 'isochrones/outer-foot-ayuntamiento.geojson'
  },
  'outer-foot-escuela-musica': {
    type: 'geojson',
    data: 'isochrones/outer-foot-escuela-musica.geojson'
  },
  'outer-foot-plaza-david-martin': {
    type: 'geojson',
    data: 'isochrones/outer-foot-plaza-david-martin.geojson'
  },
  'outer-foot-teatro-francisco-rabal': {
    type: 'geojson',
    data: 'isochrones/outer-foot-teatro-francisco-rabal.geojson'
  }
};
